import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { getMainAreaMapping, mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import CultureFlag from "components/Culture/CultureFlag";
import { VisibilityDotLabel } from "components/Dot/DotLabel";
import moment from "moment";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import VisibilityFilter from "components/filters/Filters/VisibilityFilter";
import Pill from "components/Pill/PillElement";
import { useLoaderData } from "react-router";

const WordTemplateListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WordTemplateListFrontModel>();
  const mainAreaMapping = getMainAreaMapping(viewModel.mainArea);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet={mainAreaMapping.filterSet}
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={{ ...viewModel.initialInstruction, mainArea: viewModel.mainArea }}
        fetchFunction={window.CoreApi.WordTemplate.Paginated}
        getId={item => item.wordTemplateId}
        onNew={() => window.location.href = mainAreaMapping.new()}
        layout={{
          type: "table",
          columns: [{
            key: "flag",
            header: "",
            size: "52px",
            render: item => <CultureFlag lcid={item.lcid} />
          },
          {
            key: "title",
            header: RESX.GeneralLabels.Title,
            render: item => <div>
              <a href={mainAreaMapping.detail(item.wordTemplateId)}>{item.title}</a>
              <VisibilityDotLabel visible={item.visible} />
            </div>,
            size: "2fr",
          },
          {
            key: "eSignReady",
            header: "",
            hidden: !viewModel.displayESignReadyColumn,
            render: item => {
              if (!item.eSignReady) {
                return null
              }
              return <Pill color="blue" label={RESX.ESign.eSignReady} />
            },
            size: "1fr",
          },
          {
            key: "visibleToExternal",
            header: "",
            hidden: !viewModel.displayVisibleToExternalUserColumn,
            render: item => {
              if (!item.visibleToExternal) {
                return null;
              }
              return <Pill color="orange" label={RESX.GeneralLabels.VisibleToExternalUsers} />
            },
            size: "1fr",
          },
          {
            key: "lastModified",
            header: RESX.GeneralLabels.LastModified,
            render: item => moment.utc(item.lastModifiedUtc).fromNow(),
            size: "1fr",
          }]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
          <VisibilityFilter />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction: (filterSet, filter, page, perPage) => mapFilterValuesToInstruction(viewModel.mainArea, filterSet, filter, page, perPage)
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
};

export default WordTemplateListApp;